import { useQuery } from '@tanstack/react-query';

import { getBackInStockWaitlistItems } from 'api/jalapeno';
import { FEATURE_FLAG_NAMES, useAmplitudeFeatureFlag } from 'hooks/useFeatureFlag';

import useAccountQuery from './useAccountQuery';

export const BACK_IN_STOCK_WAITLIST_ITEMS_QUERY_KEY = 'back-in-stock-waitlist-items';

const useBackInStockWaitlistItemsQuery = ({ queryProps } = {}) => {
    const { data: account } = useAccountQuery();
    const { chargeID } = account?.nextOrder ?? {};
    const { isAssignedVariant: isBackInStockWaitlistEnabled } = useAmplitudeFeatureFlag({
        flagName: FEATURE_FLAG_NAMES.BACK_IN_STOCK_WAITLIST,
        variant: 'on',
    });
    const { enabled: queryEnabled = true, ...restQueryProps } = queryProps ?? {};

    return useQuery({
        queryKey: [BACK_IN_STOCK_WAITLIST_ITEMS_QUERY_KEY, chargeID],
        queryFn: async () => {
            const response = await getBackInStockWaitlistItems(chargeID);
            return response?.data?.items ?? [];
        },
        enabled: !!chargeID && !!isBackInStockWaitlistEnabled && queryEnabled,
        ...restQueryProps,
    });
};

export default useBackInStockWaitlistItemsQuery;
